import { Injectable } from '@angular/core';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { urlServices } from './studentAdmissionUrls';
import { AnyRecordWithTtl } from 'dns';
import { encryptionService } from 'src/app/common-service/cedService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class StudentAdmissionService {
  currentyear: number;
  nextyearr: number;

  constructor(public http: HttpServiceService, public url: urlServices, public ced: encryptionService, public serverURL: ServerURLService) {

  }

  // getAllStudentAdmissionStatusCode
  getAllStudentAdmissionStatusCode() {
    return this.http.get(this.url.getAllStudentAdmissionStatusCode);
  }

  // getAllStudentAdmissionQuota
  getAllStudentAdmissionQuota() {
    return this.http.get(this.url.getAllStudentAdmissionQuota);
  }
  // getAllCourses
  getAllCourses() {
    const obj = {
      entityMasterIdEncr: this.ced.encryptAesToString(sessionStorage.getItem('entityId-usec'), this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getAllCourses, obj);
  }
   // getAllCoursesSection
   getAllCoursesSection(entityId: any) {
    const obj = {
      entityMasterIdEncr: this.ced.encryptAesToString(entityId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getAllCourses, obj);
  }
   // getAllCourses
   getAllCoursesSectionByAcademicYear(entityId: any, academicYear: any) {
    const obj = {
      entityMasterIdEncr: this.ced.encryptAesToString(entityId, this.serverURL.secretKey).toString(),
    academicYear: academicYear
    }
    return this.http.post(this.url.getAllCoursesByAcademicYear, obj);
  }
  // getSpecializationsByCourseId
  getSpecializations(courseId: any) {
    const obj = {
      courseId: courseId,
      entityMasterIdEncr: this.ced.encryptAesToString(sessionStorage.getItem('entityId-usec'), this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getSpecialisationByCourseId, obj);
  }

  // getSpecializationsByCourseId
  getSpecializationsSection(courseId: any, entityId: any) {
    const obj = {
      courseId: courseId,
      entityMasterIdEncr: this.ced.encryptAesToString(entityId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getSpecialisationByCourseId, obj);
  }

   // getSpecializationsByCourseId
  getSpecializationsSectionByAcademicYear(courseId: any, entityId: any,) {
    const obj = {
      courseId: courseId,
      entityMasterIdEncr: this.ced.encryptAesToString(entityId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getSpecialisationByCourseIdByAcademicYear, obj);
  }

   getSpecializationSectionByAcademicYear(courseId: any, entityId: any,academicYear: any) {
    const obj = {
      courseId: courseId,
      entityMasterIdEncr: this.ced.encryptAesToString(entityId, this.serverURL.secretKey).toString(),
       academicYear: academicYear
    }
    return this.http.post(this.url.getSpecialisationByCourseIdAcademicYear, obj);
  }
    // getSpecializationsByCourseId
    getSpecializationsEntityMasterId(courseId: any, entityMasterId: any) {
      const obj = {
        courseId: courseId,
        entityMasterIdEncr: this.ced.encryptAesToString(entityMasterId, this.serverURL.secretKey).toString(),
      }
      return this.http.post(this.url.getSpecialisationByCourseId, obj);
    }

  searchstudentAdmissionSectionPage(searchobj: any) {
    return this.http.post(this.url.searchstudentAdmissionSectionPage, searchobj);
  }

   searchstudentAdmissionList(searchobj: any) {
    return this.http.post(this.url.searchstudentAdmissionList, searchobj);
  }

  // searchCollegeAdmissionSectionPage(collegeSearchCriteria: any) {
  //   return this.http.post(this.url.searchCollegeAdmissionSectionPage, collegeSearchCriteria);
  // }

  fileSearchCollegeAdmissionSectionPage(collegeSearchCriteria: any) {
    return this.http.post(this.url.fileSearchCollegeAdmissionSectionPage, collegeSearchCriteria);
  }

  findAllCollegeOfferedCourseSpecialization(collegeSearchCriteria: any) {
    return this.http.post(this.url.getCollegeOfferedCourseSpecialization, collegeSearchCriteria);
  }

  searchstudentAdmissionSectionn(searchobj: any) {
    return this.http.post(this.url.searchstudentAdmissionSectionn, searchobj);
  }

   //exportStudentExcel
   exportStudentExcel(studentSearchCriteria: any) {
    return this.http.post(this.url.exportStudentExcel, studentSearchCriteria);
  }

   exportStudentsExcel(studentSearchCriteria: any) {
    return this.http.post(this.url.exportStudentsExcel, studentSearchCriteria);
  }
 //exportStudentExcel
 exportStudentReportExcel(studentSearchCriteria: any) {
  return this.http.post(this.url.exportStudentReportExcel, studentSearchCriteria);
}
  //exportStudentExcel
  exportCollegeExcel(collegeSearchCriteria: any) {
    return this.http.post(this.url.exportCollegeExcel, collegeSearchCriteria);
  }
  
  // getAllStudentsList
  getAllStudetsList(pageid: any, rowid: any) {
    return this.http.get(this.url.getAllStudents + '?page=' + pageid + '&rows=' + rowid);
  }
  // getStudentAdmissionById
  getStudentAdmissionByAdmissionID(admissionid: any) {
    const obj = {
      admissionIdEncr: this.ced.encryptAesToString(admissionid, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getStudentAdmissionByAdmissionID, obj);
  }
  // getAllClarificationsList
  getAllClarificationsList(pageid: any, rowid: any, entityid: any) {
    return this.http.get(this.url.getAllClarifications + '?page=' + pageid + '&rows=' + rowid + '&entityMasterId=' + entityid);
  }
  // getActiveStudentsList
  getActiveStudentsList(pageid: any, rowid: any, columnName: any, sortingOrder: any) {
    var d = new Date();
    var year = d.getFullYear();
    this.currentyear = year;
    this.currentyear =this.currentyear - 1;
    var nextyear = d.getFullYear() + 1;
    this.nextyearr = nextyear;
    return this.http.get(this.url.getAllActiveStudentsList + '?stauts=' + 'Verified'
      + '&acedamicYear=' + this.currentyear+ '-' + new Date().getFullYear().toString().substr(-2) + '&entityMasterId=' + sessionStorage.getItem('entityId-usec') + '&page=' + pageid + '&rows=' + rowid + '&columnName=' + columnName + '&sortingOrder=' + sortingOrder);
  }
  //getDischargeList
  getDischargeList(status, pageId: number, rowId: number, columnName: any, sortingOrder: any) {
    return this.http.get(this.url.getDischargeListOfStudent + "?stauts=" + status  + '&entityMasterId=' + sessionStorage.getItem('entityId-usec') + '&page=' + pageId + '&rows=' + rowId+ '&columnName=' + columnName+ '&sortingOrder=' + sortingOrder);
  }
    // findAll
    findAllStateBoardName() {
      return this.http.get(this.url.getAllStateBoardName);
    }
  // getAllNeetDetails By Roll No and Academic Session
  getAllNeetDetails(neetRollNo: any, academicYear: any) {
    return this.http.get(this.url.getStudentNeetResultBDSDetails + '?neetRollNo=' + neetRollNo + '&academicYear=' + academicYear);
  }

  // getAllNeetDetails By Roll No
  getAllNeetDetailsByRollno(neetRollNo: any) {
    return this.http.get(this.url.getStudentNeetResultBDSMDSDetails + '?neetRollNo=' + neetRollNo);
  }

  // getAllNeetDetails By Roll No
  getStudentNeetResultAcademicYearDetails(neetRollNo: any, academicYear: any) {
    return this.http.get(this.url.getStudentNeetResultAcademicYearDetails + '?neetRollNo=' + neetRollNo + '&academicYear=' + academicYear);
  }

  // StudentAdmissionExecutive Apicalls
  // getAllRegisteredCollegesByState
  getAllRegisteredCollegesByState(stateName: any) {
    return this.http.get(this.url.getAllRegisteredCollegesByState + '?stateName=' + stateName);
  }
  //  CollegesWithFilters
  searchCollegesWithFiltersPage(studentSearchCriteria: any) {
    return this.http.get(this.url.searchCollegesWithFilters, studentSearchCriteria);
  }

//  CollegesWithFilters
searchCollegesWithFilters(statename: any, collegeId: any, pageid: any, rowid: any) {
  return this.http.get(this.url.searchCollegesWithFilters + '?stateName=' + statename
    + '&collegeId=' + collegeId + '&page=' + pageid + '&rows=' + rowid);
}
  // findAllCollegesWithPagiantion
  findAllCollegesWithPagiantion(pageid: any, rowid: any) {
    return this.http.get(this.url.findAllCollegesByPagination + '?page=' + pageid + '&rows=' + rowid);
  }
  // findAllCollegesWithPagiantion

  collegesSearcgByPagination(pageid: any, rowid: any) {
    return this.http.get(this.url.collegesSearcgByPagination + '?page=' + pageid + '&rows=' + rowid);
    }

  findAllCollegesByPaginationOrderByCollegeName(pageid: any, rowid: any) {
  return this.http.get(this.url.findAllCollegesByPaginationOrderByCollegeName + '?page=' + pageid + '&rows=' + rowid);
  }

  findByCourseBdsColleges(pageid: any, rowid: any) {
    return this.http.get(this.url.findByCourseBdsColleges + '?page=' + pageid + '&rows=' + rowid);
    }

  // getAllStudentAdmissionByOrgAndPagination
  getAllStudentAdmissionByOrgAndPagination(entitymasterid: any, pageid: any, rowid: any, columnName: any, sortingOrder: any) {
    return this.http.get(this.url.getAllStudentAdmissionByOrgAndPagination + '?entityMasterId=' + entitymasterid + '&page=' + pageid + '&rows=' + rowid+ '&columnName=' + columnName + '&sortingOrder=' + sortingOrder);
  }
  // getAllCourses
  getAllCoursesByEntityid(entityid: any) {
    const obj = {
      entityMasterIdEncr: this.ced.encryptAesToString(entityid, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getAllCourses, obj);
  }
  // getAllEntityTypes
  getAllEntityTypes() {
    return this.http.get(this.url.getAllEntityTypes);
  }
  // getAllListOfEntityMastersByTypeId
  getAllListOfEntityMastersByTypeId(entitytypeid) {
    return this.http.get(this.url.getAllListOfEntityMastersByTypeId + '?entityTypeId=' + entitytypeid);
  }
  // processhistory
  getWorkFlowsByAdmissionId(admissionid) {
    const obj = {
      admissionIdEncr: this.ced.encryptAesToString(admissionid, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getWorkFlowsByAdmissionId, obj);
  }
   //gethistorybyid
  getWorkFlowById(id) {
    return this.http.get(this.url.getWorkFlowsById + '?id=' + id);
  }
  // generateDispatchReferenceNumber
  generateDispatchRefNo(patternNumber: any) {
    return this.http.get(this.url.generatedReferenceNo + '?pattern=' + patternNumber);
  }
  // getStudentStateDMEMstrById
  getStudentStateDMEMstrById(admissionId:any){
    const obj = {
      admissionIdEncr: this.ced.encryptAesToString(admissionId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getStudentStateDMEMstrById, obj);
  }
  // getAllStudentAdmissionChangeStatusList
  getAllStudentAdmissionChangeStatusList(statusName: any) {
    return this.http.get(this.url.getAllStudentAdmissionChangeStatusList+ '?statusName=' + statusName);
  }
  // createdispatch
  createdispatch(filearray: any, obj: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[i]);
    }
    formdata.append('dispatchJson', JSON.stringify(obj));
    return this.http.post(this.url.createDispatch, formdata);
  }
  // dean apicalls
  // post calls
  // createStudentAdmission
  createStudentAdmission(filearray: any, obj: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      // formdata.append('file', filearray[i]);
      formdata.append('file', filearray[filearray.length - 1]);
    }
    formdata.append('studentAdmissionJson', JSON.stringify(obj));
    return this.http.post(this.url.createStudentAdmission, formdata);
  }

  //createClarification
  createClarification(loginUserId: string, admissionId: any, subject: any, matter: any, fileClarification: any) {
    var formdatas: FormData = new FormData();
    for (let i = 0; i < fileClarification.length; i++) {
      formdatas.append('file', fileClarification[i]);
    }
    
    return this.http.post(this.url.createClarificationData + '?loggedInUserId=' + loginUserId + '&admissionId=' + admissionId + '&subject='
      + subject + '&assigneeComments=' + matter, formdatas);
  }

  //updateStudentAddmissionForm
  updateStudentAddmissionForm(filearray: any, obj: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      // formdata.append('file', filearray[i]);
      formdata.append('file', filearray[filearray.length - 1]);
    }
    formdata.append('studentAdmissionJson', JSON.stringify(obj));
    return this.http.post(this.url.updateStudentAdmissionForm, formdata);
  }
  // Create Clarification Response
  createResponse(workflowid: any, loginUserId: any, admissionid: any, response: any, fileClarification) {
    var formdatas: FormData = new FormData();
    for (let i = 0; i < fileClarification.length; i++) {
      formdatas.append('file', fileClarification[i]);
    }
    
    return this.http.updateData(this.url.createResponse + '?studentWorkflowID=' + workflowid + '&loggedInUserId=' + loginUserId +
      '&admissionId=' + admissionid + '&subject=' + response, formdatas);
  }
  //  searchwithMultiplefilters
  searchstudentAdmissionSection(searchobj: any) {
    return this.http.post(this.url.searchStudentAdmissionBySection, searchobj);
  }
  //  searchwithMultiplefilters
 //  searchwithMultiplefilters
 searchWithMultipleFilters(pageid: any, rowid: any, searchobj: any) {
  return this.http.post(this.url.searchWithMutipleFilters + '?page=' + pageid + '&rows=' + rowid, searchobj);
 }

  searchWithClarificationList(pageid: any, rowid: any, searchobj: any) {
    return this.http.post(this.url.searchClarificationsWithFilters + '?page=' + pageid + '&rows=' + rowid, searchobj);
  }
  // Student admission postcalls
  // create agenda
  createAgenda(agendaobj: any) {
    return this.http.post(this.url.createAgenda, agendaobj);
  }
  // seek clarifiation fromparty
  seekClarificationFromaParty(loginUserId: string, admissionId: any, subject: any, matter: any, entitymasterid: any, fileClarification: any) {
    var formdatas: FormData = new FormData();
    for (let i = 0; i < fileClarification.length; i++) {
      formdatas.append('file', fileClarification[i]);
    }
    
    return this.http.post(this.url.seekClarificationFromaParty + '?loggedInUserId=' + loginUserId + '&admissionId=' + admissionId + '&subject='
      + subject + '&assigneeComments=' + matter + '&entityMasterId=' + entitymasterid, formdatas);
  }
  // put calls
  // send To CounsellingAuthority
  sendToCounellingAuthorithy(obj: any) {
    return this.http.post(this.url.submittedToCA, obj);
  }

   updateverificationcomments(obj: any) {
    return this.http.post(this.url.verificationcomments, obj);
  }
  // update Status
  updateStatus(admissionid: any, statusname: any, matter: any, obj: any) {
    return this.http.update(this.url.updateStatus + '?admissionId=' + admissionid + '&statusName=' + statusname + '&assigneeComments=' + matter, obj);
  }

  // update Status
  updateStudentStatus(obj: any) {
    return this.http.post(this.url.updateStudentStatus, obj);
  }

  fileUpdateWithStatus(admissionid: any, statusname: any, matter: any, filearray: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[i]);
    }
   return this.http.updateData(this.url.updateStatus + '?admissionId=' + admissionid + '&statusName=' + statusname + '&assigneeComments=' + matter, formdata);
  }
  // Get Agenda Item Number
  getAgendaItemNumber() {
    return this.http.get(this.url.getAgendaItemNumber);
  }
   // post
   agendaCreate(data: any) {
    return this.http.post(this.url.agendaCreation, data);
  }
   // post
   agendaCreateStudent(data: any) {
    return this.http.post(this.url.agendaCreateStudent, data);
  }
  // Get Agenda Item Number For Student
  getAgendaItemNumberStudent() {
    return this.http.get(this.url.getAgendaItemNumberStudent);
  }

  getExistsAgendaStudent(admissionId:any) {
    const obj = {
      admissionIdEncr: this.ced.encryptAesToString(admissionId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getExistsAgendaStudent, obj);
  }

  getExistsAgendaDetailsStudent(admissionId:any) {
    return this.http.get(this.url.getExistsAgendaDetailsStudent + '?admissionId=' + admissionId);
  }

   // get existing roll number
   getexistingneetrollno(neetRollNO: any) {
    return this.http.get(this.url.getexistingneetrollno + '?neetRollNO=' + neetRollNO);
  }

   // get existing roll number
   getExistingNeetRollnoByAcademicYear(neetRollNO: any, academicYear: any) {
    return this.http.get(this.url.getExistingNeetRollnoByAcademicYear + '?neetRollNO=' + neetRollNO + '&academicYear=' + academicYear);
  }

  // getStudentsList(page: number, rows: number) {
  //   return this.http.get(this.url.studentsList + '?entityMasterId=' + sessionStorage.getItem('entityId-usec') + '&page=' + page + '&rows=' + rows)
  // }

  getStudentsList(page: number, rows: number, columnName: any, sortingOrder: any) {
    return this.http.get(this.url.studentsList + '?entityMasterId=' + sessionStorage.getItem('entityId-usec') + '&page=' + page + '&rows=' + rows + '&columnName=' + columnName + '&sortingOrder=' + sortingOrder)
  }

  //Student Status
    // getAllStudentAdmissionChangeStatusList
    getAllStudentAdmissionStatusList() {
      return this.http.get(this.url.getAllStudentAdmissionStatusList);
    }

    //Student Status
    // getAllStudentAdmissionStatusListcauniversity
    getAllStudentAdmissionStatusListcauniversity() {
      return this.http.get(this.url.getAllStudentAdmissionStatusListcauniversity);
    }
    //Export PDF
    preview(studentList){
      return this.http.post(this.url.exportPDF,studentList);
    }

    // downloadStudentListPDF(studentList) {
    //   return this.http.post(this.url.downloadStudentListPDF , studentList);
    // }

    // studentListExportPDF() {
    //   return this.http.get(this.url.downloadStudentListPDF + '?entityMasterId=' + sessionStorage.getItem('entityId-usec'))
    // }

     //  Search For Export PDF
  searchStudentExportPDFCollege(searchobj: any) {
    return this.http.post(this.url.searchStudentExportPDFCollege, searchobj);
  }

      //  Search For Export PDF
      searchStudentExportPDFSection(searchobj: any) {
        return this.http.post(this.url.searchStudentExportPDFSection, searchobj);
      }

    //   Search For Export PDF Calrification
    searchStudentExportPDFClar(searchobj: any) {
      return this.http.post(this.url.searchStudentExportPDFClar, searchobj);
    }

  //Student Admission Period
  getStudentAdmissionPeriod(academicYear: any, courseId: any){
    return this.http.get(this.url.getStudentAdmissionPeriod + '?academicYear=' + academicYear + '&courseId=' + courseId);
  }

  //Get Permitted Seat
  getPermittedSeatsCollege(academicYear: any, courseId: any, specializationid: any) {
    return this.http.get(this.url.getPermittedSeatsCollege + '?entityMasterId=' + sessionStorage.getItem('entityId-usec')
    + '&academicYear=' + academicYear + '&courseId=' + courseId + '&specialisationId=' + specializationid);
  }

   //Get Permitted Seat
   getPermittedSeatsCollegeSection(academicYear: any, courseId: any, specializationid: any, entityId: any) {
    return this.http.get(this.url.getPermittedSeatsCollege + '?entityMasterId=' + entityId
    + '&academicYear=' + academicYear + '&courseId=' + courseId + '&specialisationId=' + specializationid);
  }

   //Get Permitted Seat
   getAdmittedSeatsCollege(academicYear: any, courseId: any, specializationid: any) {
    return this.http.get(this.url.getAdmittedSeatsCollege + '?entityMasterId=' + sessionStorage.getItem('entityId-usec')
    + '&academicYear=' + academicYear + '&courseId=' + courseId + '&specialisationId=' + specializationid);
  }

  
   //Get Permitted Seat
   getAdmittedSeatsCollegeSection(academicYear: any, courseId: any, specializationid: any, entityId: any) {
    return this.http.get(this.url.getAdmittedSeatsCollege + '?entityMasterId=' + entityId
    + '&academicYear=' + academicYear + '&courseId=' + courseId + '&specialisationId=' + specializationid);
  }

  getPermittedSeatsBDSAcademicYearCount(studentSearchCriteria: any) {
    return this.http.post(this.url.getPermittedSeatsBDSAcademicYearCount, studentSearchCriteria);
  }

  // get Studnet Count List
  getVerifiedStudentCount(studentSearchCriteria: any) {
    return this.http.post(this.url.getVerifiedStudentCount, studentSearchCriteria);
  }

  //Delete Student Details 
  deleteStudent(id:any){
    const admissionIdEncr = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.deleteStudent + '?admissionIdEncr=' + admissionIdEncr);
  }

  getAdmittedSeatsCount(academicYear: any) {
    const obj = {
      academicYear: academicYear,
      entityMasterId: this.ced.encryptAesToString(sessionStorage.getItem('entityId-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getAdmittedSeatsCount, obj);
  }

  updateStudentRemarks(data: any) {
    return this.http.post(this.url.updateStudentRemarks, data);
  }

   // update Status
   updateStudentWorkflow(admissionId: any) {
    return this.http.update(this.url.updateStudentWorkflow + '?admissionId=' + admissionId, '');
  }
  // getSpecializations
  findAllSpecializations() {
    return this.http.get(this.url.getSpecialisation);
  }

   // getMDSStudentListByCollegeAndAcademicYear
   getMDSStudentList(collegeId: any, academicYear: any, courseId: any, specializationId: any) {
    const obj = {
      collegeIdEncr: this.ced.encryptAesToString(collegeId, this.serverURL.secretKey).toString(),
      academicYearEncr: this.ced.encryptAesToString(academicYear, this.serverURL.secretKey).toString(),
      courseIdEncr: this.ced.encryptAesToString(courseId, this.serverURL.secretKey).toString(),
      specializationIdEncr: this.ced.encryptAesToString(specializationId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getMDSStudentList, obj);
  }

  GetCollegeListForSection(collegeSearchCriteria: any) {
    return this.http.post(this.url.GetCollegeListForSection ,collegeSearchCriteria);
  }

  getAdmissionPeriodSection(){
    return this.http.get(this.url.getAdmissionPeriodSection);
  }

   getAdmissionPeriod(){
    return this.http.get(this.url.getAdmissionPeriod);
  }

  //getStudentPassingCriteriaProcessHistory 
  getAdmissionPeriodProcessHis(id: any ) {
    var encrypted = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getAdmissionPeriodHistoryList+'?admissionPeriodIdEncr='+encrypted);
  }

  //Save Passing Criteria
  saveStudentPassingCriteria(filearray: any, obj: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[filearray.length - 1]);
    }
    formdata.append('passingCriteriaJson', JSON.stringify(obj));
    return this.http.post(this.url.saveStudentPassingCriteria, formdata);
  }

  //get Note Sheet Content Details
  getNoteSheetContentDetails(obj: any) {
    return this.http.post(this.url.getNoteSheetContentDetails, obj);
  }
    //Save Passing Criteria
    saveNoteSheetContent(obj: any) {
      return this.http.post(this.url.saveNoteSheetContent, obj);
    }
  //getStudentPassingCriteriaList 
  getStudentPassingCriteriaList(studentAdmissionPassingCriteria: any ) {
    return this.http.post(this.url.getStudentPassingCriteriaList, studentAdmissionPassingCriteria);
  }
    //get Student Note Sheet List 
    getStudentNoteSheetList(noteSheetContantSearchCriteria: any ) {
      return this.http.post(this.url.getStudentNoteSheetList, noteSheetContantSearchCriteria);
    }

  //getStudentPassingCriteriaId 
  getStudentPassingCriteriaId(id: any ) {
    var encrypted = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getStudentPassingCriteriaId+'?decryptIdEncr='+encrypted);
  }

  //Save Passing Criteria
  savePassingCriteriaDetails(filearray: any, obj: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[filearray.length - 1]);
    }
    formdata.append('passingCriteriaDetailsJson', JSON.stringify(obj));
    return this.http.post(this.url.savePassingCriteriaDetails, formdata);
  }

  //getStudentPassingCriteriaList 
  getPassingCriteriaDetailsById(studentAdmissionPassingCriteria: any ) {
    return this.http.post(this.url.getPassingCriteriaDetailsById, studentAdmissionPassingCriteria);
  }

   //getStudentPassingCriteriaProcessHistory 
   getPassingCriteriaProcessHis(id: any ) {
    var encrypted = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getPassingCriteriaHistoryList+'?criteriaDetailsIdEncr='+encrypted);
  }

  //getStudentPassingCriteriaList 
  getPassingCriteria(id: any ) {
    var encrypted = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getPassingCriteria+'?decryptIdEncr='+encrypted);
  }

  updateOfferedCollegeCourseSepc(obj: any) {
    return this.http.post(this.url.updateOfferedCollegeCourseSepc, obj);
  }

  getOfferedCollegeCourseSepc(id: any) {
    const encrypted = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getOfferedCollegeCourseSepc + '?specialisationOfferedIdEncr='+ encrypted);
  }

  getNeetScorePassingCriteria(obj: any){
    return this.http.post(this.url.getNeetScorePassingCriteria, obj);
  }

  //Student Admission Period
  saveStudentAdmissionPeriod(filearray: any, obj: any) {
    var formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[filearray.length - 1]);
    }
    formdata.append('admissionPeriodJson', JSON.stringify(obj));
    return this.http.post(this.url.saveStudentAdmissionPeriod, formdata);
  }

  getStudentAdmissionPeriodList(studentAdmissionPeriodCriteria: any ) {
    return this.http.post(this.url.getStudentAdmissionPeriodList, studentAdmissionPeriodCriteria);
  }

  getStudentAdmissionPeriodDetails(id: any ) {
    var encrypted = encodeURIComponent(this.ced.encryptAesToString(id, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getStudentAdmissionPeriodDetails+'?decryptIdEncr='+encrypted);
  }
  
   // Get Note Sheet Details
   findAllStdAdmsnNotesheetDetails(academicYear: any, courseId: any, purposeId: any) {
    const obj = {
      academicYearEncr: this.ced.encryptAesToString(academicYear, this.serverURL.secretKey).toString(),
      courseIdEncr: this.ced.encryptAesToString(courseId, this.serverURL.secretKey).toString(),
      purposeIdEncr: this.ced.encryptAesToString(purposeId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getStdAdmsnNotesheetDetails, obj);
  }

  findAllStdAdmsnNotesheetPurpose(){
    return this.http.get(this.url.getStdAdmsnNotesheetPurpose);
  }

  checkNoteSheetInitiated(obj){
    return this.http.post(this.url.checkNoteSheetInitiatedCount, obj);
  }

  getFromDateByAdmissionPeriod(academicYear: any, courseId: any) {
    const obj = {
      academicYearEncr: this.ced.encryptAesToString(academicYear, this.serverURL.secretKey).toString(),
      courseIdEncr: this.ced.encryptAesToString(courseId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getDateByAdmissionPeriod, obj);
  }

  getVacantSeatsReport(collegeSearchCriteria: any) {
    return this.http.post(this.url.getVacantSeatsReport, collegeSearchCriteria);
  }

  //exportStudentExcel
  vacantSeatsReportExcel(exportSearchCriteria: any) {
    return this.http.post(this.url.vacantSeatsReportExcel, exportSearchCriteria);
  }

}